import styled from 'styled-components'
import { typography, color, space, layout, flexbox } from 'styled-system'

import { responsiveFontSize } from 'styles/utils'

export const TextStyled = styled.div<{ $responsiveSize: string | undefined }>`
  ${typography};
  ${color};
  ${space};
  ${layout};
  ${flexbox};
  ${({ $responsiveSize }) => ($responsiveSize ? responsiveFontSize($responsiveSize) : undefined)};
`
